import { Modal } from '@components';
import { addCommas } from '@helper';
const AvgDetailModal = ({ show, setShow, aInfo }) => {
    const setShowByParam = () => {
        setShow(!show);
    };
    if (aInfo.length > 0) {
        // console.log(JSON.stringify(aInfo));
    } else {
        return;
    }
    return (
        <Modal show={show} onHide={setShowByParam} title={'均價詳細資料'}>
            <table className="table table_sty mb-1">
                <thead>
                    <tr>
                        <th colSpan={3}>
                            股票名稱 {aInfo.stockNo}
                            {''} {aInfo.stockName}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>繳付日期</td>
                        <td>張數</td>
                        <td>成交價</td>
                    </tr>
                    {aInfo.map((row, index) => {
                        return (
                            <tr key={index}>
                                <td>{row.stockDay}</td>
                                <td>{row.shares}</td>
                                <td>
                                    <span>$</span>
                                    {addCommas(row.sharePrice)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                <button
                    className="btn_check btn rounded-pill text-white"
                    type="button"
                    onClick={() => {
                        setShowByParam();
                    }}
                >
                    確認
                </button>
            </div>
        </Modal>
    );
};

export default AvgDetailModal;
